import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconArrowRight(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M12.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L16.586 13H5a1 1 0 1 1 0-2h11.586l-4.293-4.293a1 1 0 0 1 0-1.414Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
